import { render, staticRenderFns } from "./VehicleAppsDetailCard.vue?vue&type=template&id=16d3e790"
import script from "./VehicleAppsDetailCard.vue?vue&type=script&lang=js"
export * from "./VehicleAppsDetailCard.vue?vue&type=script&lang=js"
import style0 from "./VehicleAppsDetailCard.vue?vue&type=style&index=0&id=16d3e790&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports